(function () {
  var form = document.querySelector('footer form[action^="/contact"]');
  if (!form || form.dataset.klaviyoConnected) return;
  form.dataset.klaviyoConnected = 'true';
  var busy = false;
  form.addEventListener('submit', async function (event) {
    event.preventDefault();
    if (busy || !form.reportValidity()) return;
    var field = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    var status = form.querySelector('[data-newsletter-result]');
    if (!status) { status = document.createElement('p'); status.dataset.newsletterResult = ''; status.setAttribute('role', 'status'); form.appendChild(status); }
    busy = true; button.disabled = true; status.textContent = 'Inscription en cours…';
    try {
      var response = await fetch('https://accounts.anomcafeclub.com/api/newsletter', {
        method: 'POST', headers: {'Content-Type':'application/json'},
        signal: AbortSignal.timeout(15000),
        body: JSON.stringify({email:field.value.trim(),consent:true,website:''})
      });
      if (!response.ok) throw new Error('subscription_failed');
      status.textContent = 'Vous êtes dans la boucle. À très vite pour les nouvelles du café !';
      // Keep Shopify's native newsletter record and anti-bot handling after consent is accepted.
      HTMLFormElement.prototype.submit.call(form);
    } catch (error) {
      status.textContent = 'L’inscription n’a pas abouti. Réessayez dans un instant.';
      busy = false; button.disabled = false;
    }
  });
}());
